 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		45: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~15f55eb5","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~f36e7240","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~7938afb6","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~a7bb18e3","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~StoryTemplateChunkstory-templates-public-story~StoryTemplateChunkstory-templates-video-story~e16c3a18","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-live-blog","9":"StoryTemplateChunkstory-templates-photo-story","10":"StoryTemplateChunkstory-templates-photo-story-new","11":"StoryTemplateChunkstory-templates-photo-story-old","12":"StoryTemplateChunkstory-templates-snapshot","13":"StoryTemplateChunkstory-templates-text-story","14":"StoryTemplateChunkstory-templates-text-story-new","15":"StoryTemplateChunkstory-templates-text-story-old","16":"StoryTemplateChunkstory-templates-video-story","17":"StoryTemplateChunkstory-templates-video-story-new","18":"StoryTemplateChunkstory-templates-video-story-old","19":"StoryTemplateChunkstory-templates-visual-story","20":"vendors~StoryTemplateChunkstory-templates-visual-story","21":"vendors~glide~home~list","22":"StoryTemplateChunkstory-templates-other","23":"StoryTemplateChunkstory-templates-paywall-story","24":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","25":"StoryTemplateChunkstory-templates-public-story","26":"StoryTemplateChunkstory-templates-story-selectors","27":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","28":"StoryTemplateChunkstory-templates-video-story-new-paywall-video-story","29":"StoryTemplateChunkstory-templates-video-story-new-public-video-story","30":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","31":"vendors~firebase-app~firebase-messaging","32":"vendors~home~list","34":"SSOWrapperBase","35":"SidebarTemplate","36":"StoryTemplateChunkstory-templates-blank-m-css","37":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","38":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","39":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","40":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","41":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","42":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","43":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","44":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","46":"firebase-app","48":"footer_1","49":"footer_2","50":"footer_3","51":"glide","52":"header_1","53":"header_2","54":"header_3","55":"header_4","56":"home","57":"list","58":"metypeFeedWidget","60":"qtc-parsecsv","61":"qtc-react-pdf","62":"secret-mode","64":"single-layer-header_1","65":"single-layer-header_2","66":"single-layer-header_3","67":"single-layer-header_4","68":"single-layer-header_5","69":"story","70":"subscription","71":"vendors~firebase-messaging","72":"vendors~pdfjsWorker","73":"vendors~qtc-react-pdf","74":"vendors~qtc-react-youtube","75":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + "c0c3ecee935aa4f31273" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"22":1,"23":1,"25":1,"28":1,"29":1,"32":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"62":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~15f55eb5","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~f36e7240","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~7938afb6","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~a7bb18e3","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~StoryTemplateChunkstory-templates-public-story~StoryTemplateChunkstory-templates-video-story~e16c3a18","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-live-blog","9":"StoryTemplateChunkstory-templates-photo-story","10":"StoryTemplateChunkstory-templates-photo-story-new","11":"StoryTemplateChunkstory-templates-photo-story-old","12":"StoryTemplateChunkstory-templates-snapshot","13":"StoryTemplateChunkstory-templates-text-story","14":"StoryTemplateChunkstory-templates-text-story-new","15":"StoryTemplateChunkstory-templates-text-story-old","16":"StoryTemplateChunkstory-templates-video-story","17":"StoryTemplateChunkstory-templates-video-story-new","18":"StoryTemplateChunkstory-templates-video-story-old","19":"StoryTemplateChunkstory-templates-visual-story","20":"vendors~StoryTemplateChunkstory-templates-visual-story","21":"vendors~glide~home~list","22":"StoryTemplateChunkstory-templates-other","23":"StoryTemplateChunkstory-templates-paywall-story","24":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","25":"StoryTemplateChunkstory-templates-public-story","26":"StoryTemplateChunkstory-templates-story-selectors","27":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","28":"StoryTemplateChunkstory-templates-video-story-new-paywall-video-story","29":"StoryTemplateChunkstory-templates-video-story-new-public-video-story","30":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","31":"vendors~firebase-app~firebase-messaging","32":"vendors~home~list","34":"SSOWrapperBase","35":"SidebarTemplate","36":"StoryTemplateChunkstory-templates-blank-m-css","37":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","38":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","39":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","40":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","41":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","42":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","43":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","44":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","46":"firebase-app","48":"footer_1","49":"footer_2","50":"footer_3","51":"glide","52":"header_1","53":"header_2","54":"header_3","55":"header_4","56":"home","57":"list","58":"metypeFeedWidget","60":"qtc-parsecsv","61":"qtc-react-pdf","62":"secret-mode","64":"single-layer-header_1","65":"single-layer-header_2","66":"single-layer-header_3","67":"single-layer-header_4","68":"single-layer-header_5","69":"story","70":"subscription","71":"vendors~firebase-messaging","72":"vendors~pdfjsWorker","73":"vendors~qtc-react-pdf","74":"vendors~qtc-react-youtube","75":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"c3df0332bf9c534f4de5","4":"213da90d52914217d432","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"276a7e7d7c17b01a0829","8":"665ee35876373edc0692","9":"ce14b5cd3f68e3c1f325","10":"25e145fd348257b3bd25","11":"0f05fd2fece4a3aba0d4","12":"e11e485a0ec4f77695e7","13":"2f6beb6678647a39d6d7","14":"25e145fd348257b3bd25","15":"a2240f3be0ab87cfe11b","16":"482fb6a91c1d1b21d58a","17":"fcdbd86d618eb002a826","18":"d3843e556dc3b14d2fa4","19":"8fc1345e6a4c8676e91e","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"971f25ba0301982b2608","23":"b55535a722d4b947f2ad","24":"31d6cfe0d16ae931b73c","25":"075aca9ea9eb20788764","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"d9441713e031d273095f","29":"aadb4200a6bd1b7cabf0","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"acf8c787e76c83154ad1","33":"31d6cfe0d16ae931b73c","34":"a751517e4328b0ad33d7","35":"3a48db6f0391e03de3a4","36":"775be5d7b6c5f5605d5f","37":"53849cc3faa0f7c41546","38":"799e6d3e4540d43ce49b","39":"b38bff7c081fe54aa0d0","40":"0c35b421194883ac71c1","41":"6a6ad83bd773e1e59cfd","42":"8063b69d180099ca12fe","43":"9aa9bdde99cbef6edd54","44":"1a35dbe55fc5adce6eec","46":"31d6cfe0d16ae931b73c","48":"8e2ac9f97b5b41d27941","49":"beb7efde753797a08ff7","50":"7ca80661d31bb2a8c7c2","51":"5601a62b777eb193927d","52":"a897170a26822149d1d7","53":"cc3072fac782b4cb3708","54":"c3e35fc7b382b778af01","55":"96db8a04e80e62f2fdbd","56":"4a47009d6871b0ef93bc","57":"5454811f9a3978f978e9","58":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"499d1826a1fbbe7088dc","64":"56a301bef26be30b92d9","65":"22fd139b0e9b63aaee86","66":"00161dd24339d68dfcb9","67":"8ef33fbaeedf3956d6f5","68":"8ae35b8ade9ce5c59bd7","69":"8173680172636650595e","70":"067c573f0e295f52d8da","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"69": [
 				0,
 				2,
 				3,
 				6,
 				25,
 				29,
 				1,
 				7,
 				8,
 				22,
 				23,
 				9,
 				10,
 				11,
 				13,
 				14,
 				15,
 				16,
 				17,
 				28,
 				18,
 				20,
 				19,
 				36,
 				37,
 				38,
 				39,
 				24,
 				26,
 				27,
 				41,
 				42,
 				30,
 				43,
 				44
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 194);
